import { LoanChangesHistoryState } from 'constants/loanApplication';

import {
  getApplicationChangesHistoryAction,
  getApplicationLogChangesHistoryAction,
} from 'store/loanApplications/actions';

export const FEE_TYPE_ID_PROPERTY = 'feeTypeId';

export const ApplicationChangesHistoryActionType = {
  [LoanChangesHistoryState.PENDING]: getApplicationChangesHistoryAction,
  [LoanChangesHistoryState.APPLIED]: getApplicationLogChangesHistoryAction,
};
